import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { priceValue } from "../../constants/common-constants";
import VehicleAccessoriesServiceLister from "../VehicleAccessoriesServiceLister";

const VehicleAccessories = ({ vehicleDetails, serviceListerDealerId }) => {
  const { edge = false, uiConfigData = false } =
    useSelector((state) => state?.uiConfig) || {};
  const { t } = useTranslation();
  const priceDetails = priceValue({
    consumerStandardPrice: vehicleDetails?.consumerStandardPrice,
    campaignPriceMarket: vehicleDetails?.campaignPriceMarket,
    uiConfigData,
  });
  const currency = () => {
    if (uiConfigData?.priceField === "CampaignPriceMarket") {
      return vehicleDetails?.campaignPriceMarket?.currency
        ? vehicleDetails?.campaignPriceMarket?.currency
        : vehicleDetails?.consumerStandardPrice?.currency;
    } else if (uiConfigData?.priceField === "StandardPrice") {
      return vehicleDetails?.consumerStandardPrice?.currency
        ? vehicleDetails?.consumerStandardPrice?.currency
        : vehicleDetails?.campaignPriceMarket?.currency;
    } else return vehicleDetails?.campaignPriceMarket?.currency;
  };
  const vehicle = {
    data: {
      hsn: vehicleDetails?.hsn,
      tsn: vehicleDetails?.tsn,
      serviceListerDealerId: serviceListerDealerId?.[0]?.dealerId,
      serviceListerSystem: "prod",
      currentPrice: {
        totalPrice: priceDetails?.totalPrice,
        currency: currency(),
      },
      source: "API",
      brand: vehicleDetails?.manufacturer?.name,
      serviceListerSeries: vehicleDetails?.serviceListerSeries,
    },
    id: vehicleDetails?.id,
  };
  return uiConfigData?.serviceLister?.enabled &&
    serviceListerDealerId?.length ? (
    <section className="mt-7 max-md:mt-5">
      <div className="container 2xl:max-w-[1336px] lg:max-w-[1200px] m-auto px-2">
        <div
          className={`${
            edge && edge !== "sharp" ? "rounded-[20px]" : ""
          }   bg-[var(--white-shade)] p-7 max-md:p-4"`}
        >
          <h3 className="text-[var(--primary-dark-color)] max-md:text-lg font-semibold text-2xl pb-2 relative after:h-[2px] after:max-w-[70px] after:w-full after:contents-[] after:absolute after:bottom-0 after:left-0 after:bg-[var(--primary-dark-color)]">
            {t("/vehicleDetails.Accessories")}
          </h3>
          <div className="my-6">
            <VehicleAccessoriesServiceLister vehicle={vehicle} />
          </div>
        </div>
      </div>
    </section>
  ) : null;
};
export default VehicleAccessories;
